<template>
  <div id="RealTimeTrans">
    <!-- <div class="notice">
      <h1 class="title">
        <div style="color: #B0B8DB;display: flex;justify-content: space-between;" class="footerBox">
          <div>
            <div class="span" :class="selectPage==1?'select':''" @click="change(1)">买进</div>
            <div class="span" :class="selectPage==2?'select':''" @click="change(2)">转让</div>
          </div>
          <div class="span" :class="selectPage==3?'select':''" @click="change(3)">买进转让</div>
          <div class="span" :class="selectPage==4?'select':''" @click="change(4)">预埋单</div>
          <div class="span right" @click="setting">设置</div>
          <div class="span right" @click="warning">预警</div>
          //! 显示提醒账号风险异常
          <div class="span">
            <i class="el-icon-message-solid" @click="websiteMesShow"></i>
          </div>
        </div>
      </h1>
    </div> -->
    <!-- <div class="realTHead">
      <div v-if="btnType==0" class="buyBtn">买入商品</div>
      <div v-if="btnType==1" class="sellBtn">买出商品</div>
    </div> -->
    
    <div style="height:100%">
      <!-- 订立 -->
      <RealTimeTransCC 
      v-show="selectPage==1" 
      :buy-or-sell="buyOrSell" 
      :select-trade-type="selectTradeType" 
      @emitChangeTypeLock="emitChangeTypeLock" 
      @emitChangeTypeUnlock="emitChangeTypeUnlock">
        <template #left>
              <div class="trade">
              <el-row>
                <el-col :span="3" style="width: 38px;height: 30px;padding-right:10px;">商品</el-col>
                <el-col :span="21" class="trade-select">
                  <el-select
                    :popper-append-to-body="false"
                    :value="selectItem.commodityCode"
                    size="small"
                    filterable
                    popper-class="_ccStyle "
                    placeholder="请选择商品代码"
                    @change="changeCode"
                  >
                    <el-option
                      v-for="item in commodityOptions"
                      :key="item.symbolCode"
                      :label="item.commodityCode + '  ' + item.symbol"
                      :value="item.commodityCode"
                    >
                      <div style="display: flex;align-items: center;justify-content: space-between;">
                        <span>{{ item.commodityCode }}</span>
                        <span style="color: #606266; font-size: 13px;margin-left: 40px;">{{ item.symbol }}</span>
                      </div>
                    </el-option>
                  </el-select>
                  <!-- <el-input size="small" :value="selectItem.commodityCode" /> -->
                </el-col>
                <!-- <el-col :span="7">商品名称</el-col>
                <el-col :span="17">
                  <el-input size="small" disabled :value="selectItem.symbol" />
                </el-col> -->
                <el-col :span="24">
                  <div class="tradeRadioGrop">
                    <div
                      v-for="(ty, i) in tradeTypes"
                      :key="`el-checkbox-group-trade-${i}`"
                      class="tradeRadioButton"
                      :class="{'selected':seelctTradeType===ty && seelctTradeType=='订立','selectedGreen':seelctTradeType===ty && seelctTradeType=='转让'}"
                      @click="changeSeelctTradeType(ty)"
                    >
                      {{ isXJ&&ty==='转让'?'转让/托管':ty }}
                    </div>
                  </div>
                </el-col>
              </el-row>
      <!-- <el-col :span="7" style="justify-content:flex-start">委托类型</el-col>
      <el-col :span="17">
        <el-select
          v-model="selectTradeType"
          size="small"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col> -->
            </div>
        </template>
         <template #right>
           <slot name="btn"/>
        </template>
      </RealTimeTransCC>
      <!-- 转让 -->
      <RealTimeTransCCCancel 
      v-show="selectPage==2" 
      :buy-or-sell="buyOrSell" 
      :select-trade-type="selectTradeType" 
      @emitChangeTypeLock="emitChangeTypeLock" 
      @emitChangeTypeUnlock="emitChangeTypeUnlock">
        <template #left>
              <div class="trade">
              <el-row>
                <el-col :span="3" style="width: 38px;height: 30px;padding-right:10px;">商品</el-col>
                <el-col :span="21" class="trade-select">
                  <el-select
                    :popper-append-to-body="false"
                    :value="selectItem.commodityCode"
                    size="small"
                    filterable
                    popper-class="_ccStyle "
                    placeholder="请选择商品代码"
                    @change="changeCode"
                  >
                    <el-option
                      v-for="item in commodityOptions"
                      :key="item.symbolCode"
                      :label="item.commodityCode + '  ' + item.symbol"
                      :value="item.commodityCode"
                    >
                      <span style="float: left">{{ item.commodityCode }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.symbol }}</span>
                    </el-option>
                  </el-select>
                  <!-- <el-input size="small" :value="selectItem.commodityCode" /> -->
                </el-col>
                <!-- <el-col :span="7">商品名称</el-col>
                <el-col :span="17">
                  <el-input size="small" disabled :value="selectItem.symbol" />
                </el-col> -->
                <el-col :span="24">
                  <div class="tradeRadioGrop">
                    <div
                      v-for="(ty, i) in tradeTypes"
                      :key="`el-checkbox-group-trade-${i}`"
                      class="tradeRadioButton"
                      :class="{'selected':seelctTradeType===ty && seelctTradeType=='订立','selectedGreen':seelctTradeType===ty && seelctTradeType=='转让'}"
                      @click="changeSeelctTradeType(ty)"
                    >
                      {{ isXJ&&ty==='转让'?'转让/托管':ty }}
                    </div>
                  </div>
                </el-col>
              </el-row>
      <!-- <el-col :span="7" style="justify-content:flex-start">委托类型</el-col>
      <el-col :span="17">
        <el-select
          v-model="selectTradeType"
          size="small"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col> -->
            </div>
        </template>
         <template #right>
           <slot name="btn"/>
        </template>
      </RealTimeTransCCCancel>
      <PrePay v-if="selectPage==4"></PrePay>
    </div>
    <RiskWarning :dialog-visible="isWarningOpen" @closeWarnDialog="closeWarnDialog"></RiskWarning>
    <Setting :dialog-visible="isSettingOpen" @closeSettingDialog="closeSettingDialog"></Setting>
    <websitePopup ref="websitePopup" />
  </div>
</template>
<script>
/* global hqWs hqProtocol*/
import websitePopup from './websitePopup'
import RealTimeTransCC from './RealTimeTransCC.vue'
import RealTimeTransCCCancel from './RealTimeTransCCCancel.vue'

import PrePay from './PrePay.vue'
import RiskWarning from './RiskWarning.vue'
import Setting from './Setting.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    RealTimeTransCC,
    RealTimeTransCCCancel,
    PrePay,
    RiskWarning,
    Setting,
    websitePopup
  },
  props: {
    buyOrSell: {
      type: String,
      default: 'buy'
    },
    btnType: { // 废弃
      type: Number,
      default: 0
    },
    showDOnly: { // 只显示订立
      type: Boolean,
      default: false
    },
    closeRefresh: { // 关闭top刷新
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // selectPage: 1,
      isWarningOpen: false,
      isSettingOpen: false,
      tradeTypes: ['订立', '转让'],
      seelctTradeType: '订立',
      selectTradeType: '1', // 1 数量随top变动,当为2时价格数量不再自动修改
      options: [
        {
          value: '1',
          label: '市价委托'
        },
        {
          value: '2',
          label: '限价委托'
        }
      ],
      selectItem: {},
      fData: true,
      codeOption: [],
      reloadTimer: null,
      currentUrl: '/quotationList ', // 当前路由的路径用于判断是否请求getTop
      tq_onKeyCode_A: false,
      tq_onKeyCode_Shift: false,
      tq_onKeyCode_Ctrl: false,
      tq_onKeyCode_Alt: false,
      tq_onKeyCode_F1: false,
      tq_onKeyCode_F2: false,
      tq_onKeyCode_F3: false,
      tq_onKeyCode_F4: false,
      tq_onKeyCode_Q: false,
      tq_onKeyCode_W: false,
      tq_onKeyCode_E: false,
      tq_onKeyCode_R: false,
      tq_onKeyCode_X: false,
      tq_onKeyCode_C: false,
      tq_onKeyCode_V: false,
      tq_onKeyCode_B: false,
      tq_onKeyCode_G: false,
      tq_onKeyCode_left: false,
      tq_onKeyCode_up: false,
      tq_onKeyCode_right: false,
      tq_onKeyCode_down: false,
      isXJ: window.g.APP_WINNY_NAME === '硒交在线',
      APP_TITLE_ALL: window.g.APP_TITLE_ALL,
    }
  },
  computed: {
    ...mapGetters(['marketDetails', 'item', 'dlclick', 'zrclick']),
    selectPage() {
      if (this.seelctTradeType === '订立') {
        return 1
      } else {
        return 2
      }
    },
    commodityOptions() {
      return this.$store.state.hqData.marketDetails
    }
  },
  watch: {
    item(val) {
      this.selectItem = val
      this.firstSelectItem()
    },
    marketDetails(val) {
      if (val && this.fData) {
        this.selectItem = JSON.parse(JSON.stringify(this.firstSelectItem())) // 获取第一次进入页面的商品
        this.fData = false
      }
    },
    dlclick() {
      // 切换订立
      this.changeSeelctTradeType('订立')
    },
    zrclick() {
      // 切换转让
      this.changeSeelctTradeType('转让')
    }
  },
  mounted() {
    this.fastclick()
    if (window.location.href.indexOf('quotationList') !== -1) {
      this.currentUrl = '/quotationList'
    } else {
      this.currentUrl = '/transCC'
    }
    this.selectItem = JSON.parse(JSON.stringify(this.firstSelectItem())) // 获取第一次进入页面的商品
    if (this.showDOnly) {
      this.tradeTypes = ['订立']
    }
    if (this.closeRefresh) {
      this.emitChangeTypeLock()
    }
  },
  destroyed() {
    if (this.reloadTimer) {
      clearInterval(this.reloadTimer)
      this.reloadTimer = null
    }
  },
  methods: {
    
    fastclick() {
      // 快捷键
      const _this = this
      document.onkeydown = function(e) {
        const evn = e || event
        const key = evn.keyCode || evn.which || evn.charCode
        // A
        if (key === 65) {
          _this.tq_onKeyCode_A = true
        }
        // Shift
        if (key === 16) {
          _this.tq_onKeyCode_Shift = true
        }
        // Ctrl
        if (key === 17) {
          _this.tq_onKeyCode_Ctrl = true
        }
        // Alt
        if (key === 18) {
          _this.tq_onKeyCode_Alt = true
        }
        // Q
        if (key === 81) {
          _this.tq_onKeyCode_Q = true
        }
        // W
        if (key === 87) {
          _this.tq_onKeyCode_W = true
        }
        // E
        if (key === 69) {
          _this.tq_onKeyCode_E = true
        }
        // R
        if (key === 82) {
          _this.tq_onKeyCode_R = true
        }
        // F1
        if (key === 112) {
          _this.tq_onKeyCode_F1 = true
        }
        // F2
        if (key === 113) {
          _this.tq_onKeyCode_F2 = true
        }
        // F3
        if (key === 114) {
          _this.tq_onKeyCode_F3 = true
        }
        // F4
        if (key === 115) {
          _this.tq_onKeyCode_F4 = true
        }
        // X
        if (key === 88) {
          _this.tq_onKeyCode_X = true
        }
        // C
        if (key === 67) {
          _this.tq_onKeyCode_C = true
        }
        // V
        if (key === 86) {
          _this.tq_onKeyCode_V = true
        }
        // B
        if (key === 66) {
          _this.tq_onKeyCode_B = true
        }
        // G
        if (key === 71) {
          _this.tq_onKeyCode_G = true
        }
        // 左
        if (key === 37) {
          _this.tq_onKeyCode_left = true
        }
        // 上
        if (key === 38) {
          _this.tq_onKeyCode_up = true
        }
        // 右
        if (key === 39) {
          _this.tq_onKeyCode_right = true
        }
        // 下
        if (key === 40) {
          _this.tq_onKeyCode_down = true
        }
        if (key === 121) {
          _this.$store.commit('f10click')
        }
        // if(_this.tq_onKeyCode_Shift === true && _this.tq_onKeyCode_Ctrl === true && _this.tq_onKeyCode_A === true){
        //   _this.tq_onKeyCode_Ctrl = false
        //   _this.tq_onKeyCode_Shift = false
        //   _this.tq_onKeyCode_A = false
        //   _this.shortcuts_Ctrl_Shift_A()
        // }
        // if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_X) {
        //   e.preventDefault()
        //   // _this.shortcuts_F1()
        //   _this.shortcuts_verticality()
        // }
        // if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_C) {
        //   e.preventDefault()
        //   // _this.shortcuts_F2()
        //   _this.shortcuts_verticality()
        // }
        if (_this.APP_TITLE_ALL === '尚志汇农') {
          if (_this.tq_onKeyCode_Ctrl && _this.tq_onKeyCode_left) {
            e.preventDefault()
            _this.shortcuts_dl() // 订立
          }
          if (_this.tq_onKeyCode_Ctrl && _this.tq_onKeyCode_right) {
            e.preventDefault()
            _this.shortcuts_zr() // 转让
          }
          if (_this.tq_onKeyCode_Ctrl && _this.tq_onKeyCode_up) {
            e.preventDefault()
            _this.shortcuts_buy() // 切换买
          }
          if (_this.tq_onKeyCode_Ctrl && _this.tq_onKeyCode_down) {
            e.preventDefault()
            _this.shortcuts_sell() // 切换卖
          }
          if (!_this.tq_onKeyCode_Ctrl && _this.tq_onKeyCode_up) {
            e.preventDefault()
            // _this.shortcuts_verticality() // 上下切换选中的输入框
            _this.shortcuts_verticality_up() // 上下微调价格/数量
          }
          if (!_this.tq_onKeyCode_Ctrl && _this.tq_onKeyCode_down) {
            e.preventDefault()
                      // _this.shortcuts_verticality() // 上下切换选中的输入框
            _this.shortcuts_verticality_down() // 上下微调价格/数量
          }
        } else {

          if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_left) {
            e.preventDefault()
            _this.shortcuts_dl() // 订立
          }
          if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_right) {
            e.preventDefault()
            _this.shortcuts_zr() // 转让
          }
          if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_up) {
            e.preventDefault()
            _this.shortcuts_buy() // 切换买
          }
          if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_down) {
            e.preventDefault()
            _this.shortcuts_sell() // 切换卖
          }
          if (!_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_up) {
            e.preventDefault()
            // _this.shortcuts_verticality() // 上下切换选中的输入框
            _this.shortcuts_verticality_up() // 上下微调价格/数量
          }
          if (!_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_down) {
            e.preventDefault()
                      // _this.shortcuts_verticality() // 上下切换选中的输入框
            _this.shortcuts_verticality_down() // 上下微调价格/数量
          }
        }
        // if (_this.tq_onKeyCode_Alt && _this.tq_onKeyCode_G) {
        //   e.preventDefault()
        //   _this.dialogDiscover = true
        //   setTimeout(() => {
        //     _this.$refs.dialog_lowPrice.focus()
        //   }, 1000)
        // }
      }
      document.onkeyup = function(e) {
        if (e.keyCode === 65) {
          _this.tq_onKeyCode_A = false
        }
        if (e.keyCode === 16) {
          _this.tq_onKeyCode_Shift = false
        }
        if (e.keyCode === 17) {
          _this.tq_onKeyCode_Ctrl = false
        }
        if (e.keyCode === 18) {
          _this.tq_onKeyCode_Alt = false
        }
        if (e.keyCode === 81) {
          _this.tq_onKeyCode_Q = false
        }
        if (e.keyCode === 87) {
          _this.tq_onKeyCode_W = false
        }
        if (e.keyCode === 69) {
          _this.tq_onKeyCode_E = false
        }
        if (e.keyCode === 82) {
          _this.tq_onKeyCode_R = false
        }
        if (e.keyCode === 112) {
          _this.tq_onKeyCode_F1 = false
        }
        if (e.keyCode === 113) {
          _this.tq_onKeyCode_F2 = false
        }
        if (e.keyCode === 114) {
          _this.tq_onKeyCode_F3 = false
        }
        if (e.keyCode === 115) {
          _this.tq_onKeyCode_F4 = false
        }
        // X
        if (e.keyCode === 88) {
          _this.tq_onKeyCode_X = false
        }
        // C
        if (e.keyCode === 67) {
          _this.tq_onKeyCode_C = false
        }
        // V
        if (e.keyCode === 86) {
          _this.tq_onKeyCode_V = false
        }
        // B
        if (e.keyCode === 66) {
          _this.tq_onKeyCode_B = false
        }
        // G
        if (e.keyCode === 71) {
          _this.tq_onKeyCode_G = false
        }
        // 左
        if (e.keyCode === 37) {
          _this.tq_onKeyCode_left = false
        }
        // 上
        if (e.keyCode === 38) {
          _this.tq_onKeyCode_up = false
        }
        // 右
        if (e.keyCode === 39) {
          _this.tq_onKeyCode_right = false
        }
        // 下
        if (e.keyCode === 40) {
          _this.tq_onKeyCode_down = false
        }
      }
    },
    emitChangeTypeLock() {
      this.selectTradeType = '2'
    },
    emitChangeTypeUnlock() {
      this.selectTradeType = '1'
    },
    firstSelectItem() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        for (let index = 0; index < this.$store.state.hqData.marketDetails.length; index++) {
          const element = this.$store.state.hqData.marketDetails[index]
          if (this.$store.state.hqData.item.symbolId == element.symbolId) {
            localStorage.setItem('commName', JSON.stringify(element.symbol).replace(/\"/g, ''))
            if (this.currentUrl === '/quotationList') {
              this.getTop(element.symbolId)
            }
            return JSON.parse(JSON.stringify(element))
          }
        }
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          localStorage.setItem('commName', this.$store.state.hqData.marketDetails[0].symbol)
          const obj = JSON.parse(JSON.stringify(this.$store.state.hqData.marketDetails[0]))
          if (this.currentUrl === '/quotationList') {
            this.getTop(obj.symbolId)
          }
          return obj
        } else {
          return {
            close: 0.00,
            quotechangeColor: 'white',
            quotechange: 0.00,
            high: 0,
            low: 0,
            amount: 0,
            symbolId: '--',
            clearPrice: 0
          }
        }
      }
      return ''
    },
    getTop(symbolId) {
      // 切换商品获取top用于行情列表页销售1对应买价和买量的变化
      hqProtocol.param_top.symbol = symbolId // this.$store.state.hqData.marketDetails[0].symbolId
      if (symbolId && symbolId != '--') {
        hqWs.send(hqProtocol.param_top)
        if (this.reloadTimer) {
          clearInterval(this.reloadTimer)
          this.reloadTimer = null
        }
        this.reloadTimer = setTimeout(() => {
          if (symbolId && symbolId != '--') {
            hqWs.send(hqProtocol.param_top)
          }
        }, window.g.TOP_REFRESH_TIME ? window.g.TOP_REFRESH_TIME : 1000)
      }
    },
    changeCode(code) {
      this.selectTradeType = '1' // 解锁交易组件刷新
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
        if (element.commodityCode === code) {
          this.selectItem = element
          this.$store.commit('item', element)
          localStorage.setItem('commName', element.symbol)
          if (this.currentUrl === '/quotationList') {
            this.getTop(element.symbolId)
          }
          return
        }
      })
    },
    changeSeelctTradeType(i) {
      this.seelctTradeType = i
    },
    websiteMesShow() {
      this.$refs.websitePopup.dialogShow()
    },
    change(num) {
      this.selectPage = num
    },
    setting() {
      this.isSettingOpen = true
    },
    closeSettingDialog() {
      this.isSettingOpen = false
    },
    warning() {
      this.isWarningOpen = true
    },
    closeWarnDialog() {
      this.isWarningOpen = false
    },
    // 数量/价格切换
    shortcuts_verticality() {
      this.$store.commit('verticalityclick')
    },
    // 数量/价格切换
    shortcuts_verticality_up() {
      this.$store.commit('verticalityclick_up')
    },
    // 数量/价格切换
    shortcuts_verticality_down() {
      this.$store.commit('verticalityclick_down')
    },
    // 订立
    shortcuts_dl() {
      this.$store.commit('dlclick')
    },
    // 转让
    shortcuts_zr() {
      this.$store.commit('zrclick')
    },
    // 切换买
    shortcuts_buy() {
      this.$store.commit('buyclick')
    },
    // 切换卖
    shortcuts_sell() {
      this.$store.commit('sellclick')
    }
  }
}
</script>
<style lang="scss">//新增
.el-slider__button{
  border-radius: 2px;
}

.el-slider__marks-text{
  font-size: 12px;
}
.el-slider__runway{
  background-color: rgba($color: #dedede, $alpha: 0.4);
  .el-slider__button-wrapper {
    top: -4px;
    width: 10px;
    height: 10px;
    line-height: 0;
  }
}

 .el-slider__stop{
  border-radius: 2px;
}
</style>
<style scoped lang="scss">
#RealTimeTrans{
  height: 296px;
  background-color: #141517;
  .transcc_new_NewFooter_left_top{
    display: flex;
  }
  .title {
    height: 35px;
    font-size: 14px;
    line-height: 35px;
    background:#111217;
    // text-indent:20px;
    font-weight: normal;
    .select{
      color: #DFDFDF;
      background: #D94066;
    }
  }
  .footerBox{
    // display: -webkit-flex; /* Safari */
    // position: flex;
    width: 100%;
    float: left;
    .span{
      display: inline-block;
      width: 120px;
      line-height: 35px;
      text-align: center;
      text-indent:0;
      cursor:pointer;
    }
    .right{
      float: right;
    }
  }
}
.fbText {
  width:60vw!important;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  color: red!important;
}
.realTHead{
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #464c74;
  .buyBtn {
    flex: 1;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ff0021;
  }
  .sellBtn {
    flex: 1;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgb(0, 255, 5);
  }
  .closeBtn {
    flex: 1;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #0486fe;
  }
}
.trade {
  margin-bottom: 10px;
  
  .trade-select{
    width: 174px;
    margin-bottom: 10px !important;
    /deep/ .el-select {
      .el-input__inner {
        width: 174px;
        height: 30px;
        font-family: Source Han Sans SC;
        font-weight: 200;
        font-size: 12px;
        background: transparent;
        color: #EEEEEE;
        border-radius: 4px;
        border: 1px solid #989898;
      }
      .el-input__inner:focus, .el-input.is-focus .el-input__inner{
        border-color: #989898;
      }
      .el-input__suffix{
        right: 0;
      }
      .el-input .el-select__caret{
        line-height: 14px;
      }
    }
  }
  .tradeRadioGrop{
    width: 100%;
    // height: 22px;
    border-radius: 4px;
    overflow: hidden;
    color: #fff;
    text-align: center;
    display: flex;
    justify-content: space-between;
    .tradeRadioButton{
      cursor: pointer;
      flex: auto;
      width: 90px;
      height: 30px;
      background-color: rgba($color: #cecece, $alpha: 0.1);
      font-family: Source Han Sans SC;
      font-weight: bold;
      font-size: 14px;
      color: #989898;
      line-height: 30px;
    }
    .selected {
      color: #DFDFDF;
      background: #D94066;
    }
    .selectedGreen {
      color: #DFDFDF;
      background: #41B37D;
      
    }
  }
}

  /deep/ .el-radio-group .el-radio-button__inner {
    background: transparent;
    width: 111px;
    border-color: rgba(220, 223, 230, 0.3);
    color: rgba(255, 255, 255, 0.4);
  }
  // 选中
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: transparent;
    color: #0486fe;
    border-color: rgba(220, 223, 230, 0.3);
  }
  .buyStep {
    width: 100%;
  }
  /deep/ .el-slider {
    width: 100%;
  }
  /deep/ .el-col {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    // margin: 4px 0;
    // 文字属性
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 14px;
    color: #EEEEEE;
  }
  /deep/ .el-radio-group{
    display: flex;
    /deep/.el-radio-button{
      flex: auto;
    }
  }
</style>
<style lang='scss'>
._ccStyle .el-popper{
  // width: 231px !important;
  background: #121212;
  .el-scrollbar__wrap{
    margin-right: -8px !important;
    margin-bottom: -8px !important;
  }
}
</style>